import styles from './DocumentTemplate.module.sass';

const DocumentTemplate = ({
    children,
    headerHeight,
    footerHeight
}) => {
    return <div className={styles['document-template']}>
        <table>
            <thead style={{display: 'table-header-group'}}>
                <tr>
                    <td>
                        <div style={{
                            height: headerHeight,
                            background: 'rgba(0, 0, 0, .0)'
                        }} />
                    </td>
                </tr>
            </thead>

            <tbody>
                <tr>
                    <td>
                        { children }
                    </td>
                </tr>
            </tbody>

            <tfoot style={{display: 'table-footer-group'}}>
                <tr>
                    <td>
                        <div style={{
                            height: footerHeight,
                            background: 'rgba(0, 0, 0, .0)'
                        }} />
                    </td>
                </tr>
            </tfoot>
        </table>
    </div>;
}

export default DocumentTemplate;